export function PageLoading() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="flex items-center gap-3 text-[color:var(--text-muted)]">
        <span className="w-2 h-2 rounded-full bg-[color:var(--gold)] animate-pulse" />
        <span className="w-2 h-2 rounded-full bg-[color:var(--gold)] animate-pulse [animation-delay:120ms]" />
        <span className="w-2 h-2 rounded-full bg-[color:var(--gold)] animate-pulse [animation-delay:240ms]" />
      </div>
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="rounded-2xl border border-[color:var(--border-c)] bg-[color:var(--surface)] overflow-hidden animate-pulse">
      <div className="aspect-[16/9] bg-[color:var(--surface-2)]" />
      <div className="p-4 space-y-2">
        <div className="h-4 w-3/4 bg-[color:var(--surface-2)] rounded" />
        <div className="h-3 w-1/2 bg-[color:var(--surface-2)] rounded" />
        <div className="h-9 w-full bg-[color:var(--surface-2)] rounded mt-2" />
      </div>
    </div>
  );
}
